import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export type VisitorEventLayoutView =
  | 'default'
  | 'basic'
  | 'calendar'
  | 'list'
  | 'square'
  | 'fancy'
  | 'long'
  | 'modern-block'
  | 'vertical';

@Injectable({
  providedIn: 'root',
})
export class VisitorEventLayoutService {
  private readonly selectedLayoutSubject = new BehaviorSubject<VisitorEventLayoutView>('default');

  readonly selectedLayout$ = this.selectedLayoutSubject.asObservable();

  get selectedLayout(): VisitorEventLayoutView {
    return this.selectedLayoutSubject.value;
  }

  setSelectedLayout(layout: VisitorEventLayoutView) {
    if (this.selectedLayoutSubject.value === layout) return;

    this.selectedLayoutSubject.next(layout);
  }

  reset() {
    this.setSelectedLayout('default');
  }
}
